import { BRAND_COLORS, COLORS_BASIC, FUNCTIONAL_COLORS } from '../../dsm/color';
import { backgroundColor, borderColor, brandColor, palette, textColor } from '../../dsm/color-token';
export const bifrostProductColorToken = {
  'product-color': '#00854E',
  'product-color-light-100': '#39A478',
  'product-color-light-200': '#72C3A2',
  'product-color-light-300': '#ABE2CC',
  'product-color-light-400': '#E5FFF4',
  'product-color-dark-100': '#006B3F',
  'product-color-dark-200': '#00502F',
  'product-color-dark-300': '#00351F',
  'product-color-dark-400': '#001A0F'
};
const componentsColor = {
  'color-charts-primary': bifrostProductColorToken['product-color-dark-100'],
  'color-charts-secondary': bifrostProductColorToken['product-color-light-300']
};
export const bifrostColor = {
  COLORS_BASIC,
  COLORS: { ...BRAND_COLORS,
    ...FUNCTIONAL_COLORS
  },
  colors: { ...bifrostProductColorToken,
    ...palette,
    ...backgroundColor,
    ...textColor,
    ...borderColor,
    ...componentsColor,
    ...brandColor
  }
};